import React from "react";
import { Col, FormFeedback, Input, Label, Row } from "reactstrap";
import * as Yup from "yup";

import { fetchWrapper } from "@helpers/fetchwrapper";

import styles from "@areas/shared/components/personal/modals/styles/customModal.module.css";

const initialValues = (specialistNeed, company) => {
  return {
    id: (specialistNeed && specialistNeed.Id) || null,
    specialist: (specialistNeed && specialistNeed.Specialist) || "",
    industry: (specialistNeed && specialistNeed.Industry) || "",
    salaryMin:
      specialistNeed && specialistNeed.SalaryMin != null
        ? specialistNeed.SalaryMin
        : "",
    salaryMax:
      specialistNeed && specialistNeed.SalaryMax != null
        ? specialistNeed.SalaryMax
        : "",
    idCompany: (company && company.IdCompany) || 0,
  };
};

const validationSchema = () => {
  return Yup.object({
    specialist: Yup.string().required("Значение обязательно"),
    industry: Yup.string(),
    salaryMin: Yup.number()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .min(0, "Значение не может быть отрицательным"),
    salaryMax: Yup.number()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .min(0, "Значение не может быть отрицательным")
      .when("salaryMin", (salaryMin, schema) => {
        if (salaryMin != null && salaryMin !== "") {
          return schema.min(salaryMin, "Максимум не может быть меньше минимума");
        }
        return schema;
      }),
  });
};

const confirm = (values, successFunc) => {
  const data = new FormData();

  data.append("IdCompany", values.idCompany);
  data.append("Specialist", values.specialist);
  data.append("Industry", values.industry || "");

  if (values.salaryMin !== "" && values.salaryMin != null) {
    data.append("SalaryMin", values.salaryMin);
  }
  if (values.salaryMax !== "" && values.salaryMax != null) {
    data.append("SalaryMax", values.salaryMax);
  }

  if (values.id) {
    data.append("Id", values.id);
    fetchWrapper
      .post(`/v1/api/app/UpdateSpecialistNeed`, data, false)
      .then(() => successFunc());
  } else {
    fetchWrapper
      .post(`/v1/api/app/InsertSpecialistNeed`, data, false)
      .then(() => successFunc());
  }
};

function ModalBodyAdd({ validation }) {
  return (
    <Row className="g-2">
      <Input
        type="hidden"
        name="id"
        defaultValue={validation.values.id || null}
      />
      <Input
        type="hidden"
        name="idCompany"
        defaultValue={validation.values.idCompany || 0}
      />
      <Col sm={12}>
        <div>
          <Label htmlFor="specialistNeedSpecialist-field" className={styles.label}>
            Специалист
          </Label>
          <Input
            name="specialist"
            id="specialistNeedSpecialist-field"
            className={`form-control ${styles.input}`}
            placeholder="Введите название специальности"
            type="text"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.specialist || ""}
            invalid={
              validation.touched.specialist && validation.errors.specialist
                ? true
                : false
            }
          />
          {validation.touched.specialist && validation.errors.specialist ? (
            <FormFeedback type="invalid" className={styles.invalid}>
              {validation.errors.specialist}
            </FormFeedback>
          ) : null}
        </div>
      </Col>
      <Col sm={12}>
        <div>
          <Label htmlFor="specialistNeedIndustry-field" className={styles.label}>
            Отрасль
          </Label>
          <Input
            name="industry"
            id="specialistNeedIndustry-field"
            className={`form-control ${styles.input}`}
            placeholder="Введите отрасль"
            type="text"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.industry || ""}
          />
        </div>
      </Col>
      <Col sm={6}>
        <div>
          <Label htmlFor="specialistNeedSalaryMin-field" className={styles.label}>
            Зарплата от
          </Label>
          <Input
            name="salaryMin"
            id="specialistNeedSalaryMin-field"
            className={`form-control ${styles.input}`}
            placeholder="Минимальная зарплата"
            type="number"
            min="0"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.salaryMin ?? ""}
            invalid={
              validation.touched.salaryMin && validation.errors.salaryMin
                ? true
                : false
            }
          />
          {validation.touched.salaryMin && validation.errors.salaryMin ? (
            <FormFeedback type="invalid" className={styles.invalid}>
              {validation.errors.salaryMin}
            </FormFeedback>
          ) : null}
        </div>
      </Col>
      <Col sm={6}>
        <div>
          <Label htmlFor="specialistNeedSalaryMax-field" className={styles.label}>
            Зарплата до
          </Label>
          <Input
            name="salaryMax"
            id="specialistNeedSalaryMax-field"
            className={`form-control ${styles.input}`}
            placeholder="Максимальная зарплата"
            type="number"
            min="0"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.salaryMax ?? ""}
            invalid={
              validation.touched.salaryMax && validation.errors.salaryMax
                ? true
                : false
            }
          />
          {validation.touched.salaryMax && validation.errors.salaryMax ? (
            <FormFeedback type="invalid" className={styles.invalid}>
              {validation.errors.salaryMax}
            </FormFeedback>
          ) : null}
        </div>
      </Col>
    </Row>
  );
}

export { initialValues, validationSchema, confirm, ModalBodyAdd };
